import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionMatchEvent } from './competition-match-event'
import { competitionMatchEventActions } from './competition-match-event.actions'
import * as fromCompetitionMatchEvent from './competition-match-event.reducer'
import { CompetitionMatchEventService } from './competition-match-event.service'

@Injectable()
export class CompetitionMatchEventEffects extends ResourceEffects<CompetitionMatchEvent> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionMatchEventService: CompetitionMatchEventService
  ) {
    super(
      fromCompetitionMatchEvent.FEATURE_NAME,
      competitionMatchEventService,
      competitionMatchEventActions,
      actions$
    )
  }
}
